import { BedDouble, Hotel, Castle, Home, Tent, HelpCircle, Building2 } from 'lucide-react';

export const ACCOMMODATION_STYLES = [
    { value: 'hostel', label: 'Hostel', icon: Tent, hint: 'Bunks & shared kitchens' },
    { value: 'budget_hotel', label: 'Budget hotel', icon: BedDouble, hint: 'Simple, clean rooms' },
    { value: 'mid_range', label: 'Mid-range hotel', icon: Hotel, hint: 'Comfort & character' },
    { value: 'luxury', label: 'Luxury', icon: Castle, hint: 'High-end experiences' },
    { value: 'airbnb', label: 'Airbnb / apartment', icon: Home, hint: 'Live like a local' },
    { value: 'no_pref', label: 'No preference', icon: HelpCircle, hint: 'I’m flexible' },
];

export const ACCOMMODATION_PRIORITIES = [
    { value: 'near_transport', label: 'Near public transport' },
    { value: 'near_center', label: 'Near city center' },
    { value: 'near_nightlife', label: 'Near nightlife' },
    { value: 'pool', label: 'Has pool' },
    { value: 'kitchen', label: 'Has kitchen' },
    { value: 'quiet', label: 'Quiet area' },
    { value: 'boutique', label: 'Unique or boutique' },
];

export const FOOD_PRIORITIES = [
    { value: 'local_street', label: 'Local street food' },
    { value: 'casual_local', label: 'Casual local restaurants' },
    { value: 'cafes', label: 'Cafés and brunch spots' },
    { value: 'fine_dining', label: 'Fine dining or Michelin' },
    { value: 'markets', label: 'Markets and home cooking' },
    { value: 'no_pref', label: 'No strong preference' },
];

export const PACE_OPTIONS = [
    { value: 'packed', label: 'Packed', hint: 'See everything' },
    { value: 'moderate', label: 'Moderate', hint: 'A nice balance' },
    { value: 'relaxed', label: 'Relaxed', hint: 'No rushing' },
];

export const WAKE_OPTIONS = [
    { value: 'early', label: 'Early bird', hint: 'Before 8am' },
    { value: 'morning', label: 'Morning', hint: '8 – 10 am' },
    { value: 'late', label: 'Sleep in', hint: 'After 10am' },
];

export const WALKING_OPTIONS = [
    { value: 'all_day', label: 'Walk all day', hint: 'Bring it on' },
    { value: 'mix', label: 'Mix it up', hint: 'Walk + transit' },
    { value: 'minimal', label: 'Minimal walking', hint: 'Mostly transit' },
];

export const INTERESTS = [
    { key: 'history_culture', label: 'History and culture' },
    { key: 'nature_outdoors', label: 'Nature and outdoors' },
    { key: 'shopping', label: 'Shopping' },
    { key: 'nightlife', label: 'Nightlife' },
    { key: 'photography', label: 'Photography spots' },
    { key: 'art_museums', label: 'Art and museums' },
    { key: 'adventure', label: 'Adventure or extreme activities' },
];

export const RATINGS = [
    { value: 'love', label: 'Love', color: '#4A7C59' },
    { value: 'neutral', label: 'Neutral', color: '#8A8175' },
    { value: 'skip', label: 'Skip', color: '#D05C45' },
];

// Lookup helpers
const lookup = (arr, key = 'value') => Object.fromEntries(arr.map(o => [o[key], o]));
export const ACC_STYLE_MAP = lookup(ACCOMMODATION_STYLES);
export const ACC_PRIO_MAP = lookup(ACCOMMODATION_PRIORITIES);
export const FOOD_PRIO_MAP = lookup(FOOD_PRIORITIES);
export const PACE_MAP = lookup(PACE_OPTIONS);
export const WAKE_MAP = lookup(WAKE_OPTIONS);
export const WALKING_MAP = lookup(WALKING_OPTIONS);
export const INTEREST_MAP = lookup(INTERESTS, 'key');
export const RATING_MAP = lookup(RATINGS);
